import { createPostFetch } from '../../../lib/createFetch';
import { ChangePasswordRes } from '../../../pages/api/auth/changePassword';
import { ChangePasswordReq } from '../../../pages/api/auth/changePassword';
import { CheckOrgRegisteredReq } from '../../../pages/api/auth/checkOrgRegistered';
import { CheckOrgRegisteredRes } from '../../../pages/api/auth/checkOrgRegistered';
import { CheckPasswordRestoreCodeReq } from '../../../pages/api/auth/checkPasswordRestoreCode';
import { CheckPasswordRestoreCodeRes } from '../../../pages/api/auth/checkPasswordRestoreCode';
import { CheckUserRegisteredRes } from '../../../pages/api/auth/checkUserRegistered';
import { CheckUserRegisteredReq } from '../../../pages/api/auth/checkUserRegistered';
import { CreatePasswordRestoreCodeRes } from '../../../pages/api/auth/createPasswordRestoreCode';
import { CreatePasswordRestoreCodeReq } from '../../../pages/api/auth/createPasswordRestoreCode';
import { RegistrationRes } from '../../../pages/api/auth/register';
import { RegistrationReq } from '../../../pages/api/auth/register';
import { RegisterInviteRes } from '../../../pages/api/auth/registerInvite';
import { RegisterInviteReq } from '../../../pages/api/auth/registerInvite';

export const checkUserRegistered = createPostFetch<
    CheckUserRegisteredReq,
    CheckUserRegisteredRes
>('/api/auth/checkUserRegistered');

export const checkOrgRegistered = createPostFetch<
    CheckOrgRegisteredReq,
    CheckOrgRegisteredRes
>('/api/auth/checkOrgRegistered');

export const register = createPostFetch<RegistrationReq, RegistrationRes>(
    '/api/auth/register'
);

export const createPasswordRestoreCode = createPostFetch<
    CreatePasswordRestoreCodeReq,
    CreatePasswordRestoreCodeRes
>('/api/auth/createPasswordRestoreCode');

export const checkPasswordRestoreCode = createPostFetch<
    CheckPasswordRestoreCodeReq,
    CheckPasswordRestoreCodeRes
>('/api/auth/createPasswordRestoreCode');

export const changePassword = createPostFetch<
    ChangePasswordReq,
    ChangePasswordRes
>('/api/auth/changePassword');

export const registerInvite = createPostFetch<
    RegisterInviteReq,
    RegisterInviteRes
>('/api/auth/registerInvite');
